import { render, staticRenderFns } from "./AdminDevices.vue?vue&type=template&id=08b65b07&scoped=true"
import script from "./AdminDevices.vue?vue&type=script&lang=js"
export * from "./AdminDevices.vue?vue&type=script&lang=js"
import style0 from "./AdminDevices.vue?vue&type=style&index=0&id=08b65b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b65b07",
  null
  
)

export default component.exports